import { createCustomEnum } from "./customEnum";

const TypeOfBusinessValues = createCustomEnum({
	SoleProp: {
		value: 0,
		name: "SoleProp",
		displayName: "Sole Proprietor",
	},
	LLC: {
		value: 1,
		name: "LLC",
		displayName: "Limited Liability Company",
	},
	PrivateCorporation: {
		value: 2,
		name: "PrivateCorporation",
		displayName: "Private Corporation",
	},
	PublicCorporation: {
		value: 7,
		name: "PublicCorporation",
		displayName: "Public Corporation",
	},
	Partnership: {
		value: 3,
		name: "Partnership",
		displayName: "Partnership",
	},
	Government: {
		value: 8,
		name: "Government",
		displayName: "Government",
	},
	TrustEstate: {
		value: 4,
		name: "TrustEstate",
		displayName: "Trust / Estate",
	},
	TaxExtemp501c: {
		value: 5,
		name: "TaxExtemp501c",
		displayName: "Tax Exempt 501 (c)(3)",
	},
	Other: {
		value: 6,
		name: "Other",
		displayName: "Other",
	},
});

export default TypeOfBusinessValues;
